<template>
    <v-menu
        v-model                 = "menu"
        :offset-y               = "true"
        :close-on-content-click = "false"
        :max-height             = "height"
        content-class           = "dialog-border"
        nudge-bottom            = "6"
        bottom
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class  = "dialog-button"
                v-bind = "attrs"
                v-on   = "on"
                color  = "white"
                depressed
            >
                <div style="display: block">
                    <div>
                        <v-icon color="primary" size="22">{{ icon }}</v-icon>
                    </div>
                    <div class="primary--text button-label">{{ label }}</div>
                </div>
            </v-btn>
        </template>

        <div class="white">
            <slot name="content" v-bind:open = "menu"></slot>
        </div>
    </v-menu>
</template>

<script>
export default {
    name: "PIncToolbarButton",

    props: {
        icon: {

        },

        label: {

        },

        height: {

        }
    },

    data: () => ({
        menu: false
    }),

    watch: {
        menu () {
            if (this.menu) {
                this.$emit("opened");
            }
        }
    },

    methods: {
        close () {
            this.menu = false;
        }
    }
}
</script>

<style scoped>

.button-label {
    font-size: 12px;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 48px;
    padding: 0!important;
}

</style>